import PostCard from './PostCard';
import '../styles/posts.scss';

export default function PopularPosts({ popularPostsData }) {
  if (!popularPostsData || popularPostsData?.length === 0) {
    return null;
  }
  return (
    <div className="posts-container">
      <h2 className="posts-title">Popular Posts</h2>
      <div className="demographics-card post-cards-container">
        {popularPostsData?.slice(0, 3)?.map((data, index) => (
          <PostCard
            key={index}
            image={data.thumbnail}
            link={data.link}
            description={data.text}
            likesCount={data.stat.likes}
            commentsCount={data.stat.comments}
            postedOn={data.created}
          />
        ))}
      </div>
    </div>
  );
}
